import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';


const useStyles = makeStyles(theme => ({
    formControl: {
        marginBottom: 0,
        marginRight: 2,
        '& .MuiRadio-root': {
            paddingTop: 4,
            paddingBottom: 4,
        },
        '& .MuiFormControlLabel-label': {
            flexGrow: 1,
        }
    }
}));

const PaymentEmailDialog = props => {
    const {
        open,
        selected,
        setOpen,
        setSnackbarMessage,
        setOpenSnackbar
    } = props;

    if (!selected.wedding) {
        return (
            <div></div>
        )
    }

    const classes = useStyles();

    const defaultFormState = {
        paymentEmail: true,
        invoiceEmail: false,
        loginInfoEmail: false,
        password: '',
    };
    const [formState, setFormState] = React.useState(defaultFormState);
    const updateState = (value, name) => {
        const data = {
            ...formState,
            [name]: value,
        };
        setFormState(data);
    }
    const handleChange = name => event => {
        let value;
        if (name == 'password') {
            value = event.target.value
        } else {
            value = event.target.checked;
        }
        updateState(value, name);
    }
    const emailPayment = selected => {
        const data = { _token: window._token, selectedEmails: formState }
        new Promise((resolve, reject) => {
            let url = `/admin/payments/${selected.id}/notify`;
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setSnackbarMessage('Email was successfully sent');
                    setOpenSnackbar(true);
                    resolve();
                })
                .catch(reason => {
                    alert('An error prevented emailing the payment. Please refresh the page and try again.');
                })
        });
    }
    const handleCloseEmailDialog = action => () => {
        if (action == 'payment') {
            emailPayment(selected);
        }
        setFormState(defaultFormState);
        setOpen(false);
    };

    const invoiceCount = selected.wedding && selected.wedding.invoices ? selected.wedding.invoices.length : 0;
    let mostRecentInvoice;
    if (invoiceCount) {
        mostRecentInvoice = selected.wedding.invoices[invoiceCount-1];
    }

    return (
        <Dialog
            open={open}
            onClose={handleCloseEmailDialog(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Email payment notification</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" component="div">
                    <span>Are you sure you wish to email {selected.wedding.bride_first_name} and {selected.wedding.groom_first_name}?</span>
                    {invoiceCount > 0 && (
                        <React.Fragment>
                            <br /><br />
                            <span>Number of invoices: {invoiceCount}</span>
                            <br />
                            <span>Most recent invoice: ${parseFloat(mostRecentInvoice.total).toFixed(2)} due {mostRecentInvoice.date_due_formatted}</span>
                        </React.Fragment>
                    )}
                    <Grid item xs={12} style={{marginTop: 20}}>
                        <FormGroup>
                            <FormControlLabel
                                className={classes.formControl}
                                control={
                                    <Checkbox color="primary" id="invoice-email" checked={formState.invoiceEmail} onChange={handleChange('invoiceEmail')} />
                                }
                                label="Send invoice email"
                            />
                            <FormControlLabel
                                className={classes.formControl}
                                control={
                                    <Checkbox color="primary" id="login-info-email" checked={formState.loginInfoEmail} onChange={handleChange('loginInfoEmail')} />
                                }
                                label="Send login info email"
                            />
                        </FormGroup>
                    </Grid>
                    {formState.loginInfoEmail && (
                        <Grid item xs={12}>
                            <TextField
                                id="password"
                                label="Password"
                                value={formState.password || ''}
                                onChange={handleChange('password')}
                                fullWidth
                                placeholder="Enter a new password or leave blank to keep current password"
                            />
                        </Grid>
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseEmailDialog('payment')} color={"primary"}>
                    Email
                </Button>
                <Button onClick={handleCloseEmailDialog('decline')} autoFocus>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PaymentEmailDialog;
